angular.module("UI8.components").component("hireModal", {
  template: `<div ng-class="{success: $ctrl.isSubmitted}" class="modal modal--hire">
      <button class="modal__close" ui8-toggle-class="hire-modal" ui8-track-event="Close Hire Modal"></button>
      <div class="modal__container">
        <div class="hire">

          <div class="hire__step" ng-if="!$ctrl.isSubmitted">
            <div class="hire__title">Hire {{ $ctrl.authorName }}</div>
            <div class="hire__form">
              <div class="hire__row">
                <div class="field">
                  <div class="field__label">Project type</div>
                  <select class="field__input" ng-model="$ctrl.brief.project_type" ng-options="t for t in $ctrl.projectTypes"><option value="">Select a project type</option></select>
                </div>
                <div class="field">
                  <div class="field__label">Budget</div>
                  <select class="field__input" ng-model="$ctrl.brief.budget_range" ng-options="b for b in $ctrl.budgets"><option value="">Select a budget</option></select>
                </div>
              </div>
              <div class="field">
                <div class="field__label">Timeline</div>
                <select class="field__input" ng-model="$ctrl.brief.timeline" ng-options="t for t in $ctrl.timelines"><option value="">Select a timeline</option></select>
              </div>
              <div class="field">
                <div class="field__label">Project details</div>
                <textarea class="field__textarea" ng-model="$ctrl.brief.description" name="hire-message" placeholder="Tell {{ $ctrl.authorName }} what your project is about, provide as many details as possible..."></textarea>
              </div>
              <button class="btn btn--submit" ng-if="!$ctrl.isSubmitting" ng-disabled="!$ctrl.brief.description" ng-click="$ctrl.submitMessage()">Send inquiry</button>
              <div class="loader" ng-if="$ctrl.isSubmitting"></div>
            </div>
          </div>

          <div class="hire__step" ng-if="$ctrl.isSubmitted && !$ctrl.confirmed">
            <div class="hire__title">Inquiry sent</div>
            <div class="hire__content">
              <p>Your inquiry is on its way to {{ $ctrl.authorName }}. Replies land in your UI8 inbox and you'll get an email when they respond.</p>
            </div>
            <a class="btn btn--submit" ng-href="/account/inbox/{{ $ctrl.threadId }}">Open conversation</a>
          </div>

          <div class="hire__step" ng-if="$ctrl.success === 1">
            <div class="hire__title">Message sent</div>
            <div class="hire__content">
              <p>Your email has been confirmed and your message has been delivered to {{ $ctrl.authorName }}.</p>
            </div>
            <button class="btn btn--submit" ng-click="$ctrl.resetForm()">Send new inquiry</button>
          </div>

          <div class="hire__step" ng-if="$ctrl.success === 0">
            <div class="hire__title">Unable to deliver message</div>
            <div class="hire__content">
              <p>We were unable to deliver your message to {{ $ctrl.authorName }}.</p>
              <p>Please contact support.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__backdrop" ui8-toggle-class="hire-modal" ui8-track-event="Close Hire Modal"></div>
    </div>`,

  controller: function (HireService, FlashService, $scope) {
    var ctrl = this;

    ctrl.projectTypes = [
      "Web design",
      "Mobile app design",
      "Branding",
      "Illustration",
      "3D",
      "Motion",
      "Other",
    ];
    ctrl.budgets = [
      "Under $1,000",
      "$1,000 – $5,000",
      "$5,000 – $10,000",
      "$10,000+",
    ];
    ctrl.timelines = ["ASAP", "Within a month", "1–3 months", "Flexible"];

    ctrl.isSubmitting = false;
    ctrl.isSubmitted = false;
    ctrl.brief = {};

    ctrl.$onInit = function () {
      ctrl.authorName =
        ctrl.author.display_name ||
        ctrl.author.first_name + " " + ctrl.author.last_name;

      // Legacy: stale double-opt-in confirm links land with ?success=
      if (ctrl.success === 0 || ctrl.success === 1) {
        ctrl.isSubmitted = true;
        ctrl.confirmed = true;
      }
    };

    ctrl.submitMessage = function () {
      if (!UI8.loggedIn) {
        window.location =
          "/account/login?from=" +
          encodeURIComponent(window.location.pathname);
        return;
      }
      if (ctrl.isSubmitting) return;
      ctrl.isSubmitting = true;

      HireService.createThread({
        to: ctrl.author._id,
        project_type: ctrl.brief.project_type,
        budget_range: ctrl.brief.budget_range,
        timeline: ctrl.brief.timeline,
        description: ctrl.brief.description,
      }).then(function (res) {
        ctrl.isSubmitting = false;

        if (res && res.paywall) {
          $("body")
            .removeClass("hire-modal")
            .addClass("hire-paywall-modal");
          $scope.$applyAsync();
          return;
        }

        if (!res || res.error) {
          FlashService.set(
            "error",
            (res && res.error) || "Unable to send message"
          );
          $scope.$applyAsync();
          return;
        }

        ctrl.threadId = res.thread;
        ctrl.isSubmitted = true;
        $scope.$applyAsync();
      });
    };

    ctrl.resetForm = function () {
      ctrl.brief = {};
      ctrl.isSubmitted = false;
      ctrl.success = false;
      ctrl.confirmed = false;
    };
  },

  bindings: {
    author: "<",
    success: "<",
  },
});
